import { injectable } from 'inversify';
import { ToastMessageType } from 'src/components/ToastMessage/types';
import { LocalStorageUtility } from '../utilities/localStorage.utility';
import { EventsManagerImpl } from '../utilities/events-manager.utility';

export enum NOTIFICATION_TYPE {
  SUCCESS = 'success',
  WARNING = 'warning',
}

export enum NOTIFICATION_ACTIONS {
  update = `notification_update`,
}

export const NOTIFICATION_DEFAULT_TIME = 6000;

export interface Notification {
  id: number;
  text: string;
  time: number;
  type: ToastMessageType;
}

export interface NotificationService {
  notifications: Notification[];
  success(text: string, time?: number, type?: ToastMessageType): void;
  warning(text: string, time?: number, type?: ToastMessageType): void;
  showUmamiNotificationAfterRedirect(message: string, type?: string): void;
}

@injectable()
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export class NotificationServiceImpl implements NotificationService {
  public static instance: NotificationService;
  public notifications: Notification[] = [];
  private eventsManager = EventsManagerImpl.getInstance();
  private umamiStorage = new LocalStorageUtility({
    storagePrefix: 'ngStorage',
  });

  public success = (
    text: string,
    time = NOTIFICATION_DEFAULT_TIME,
    type = ToastMessageType.SUBSCRIPTION_SUCCESS,
  ) => this.push(text, time, type);
  public warning = (
    text: string,
    time = NOTIFICATION_DEFAULT_TIME,
    type = ToastMessageType.SUBSCRIPTION_WARNING,
  ) => this.push(text, time, type);

  public showUmamiNotificationAfterRedirect(message: string, type = 'warning') {
    let notifications = this.umamiStorage.get('notifications');

    if (!Array.isArray(notifications)) {
      notifications = [];
    }

    notifications.push({ message, type });
    this.umamiStorage.set('notifications', notifications);
  }

  private push = (text: string, time: number, type: ToastMessageType): void => {
    const notification: Notification = {
      id: Date.now(),
      text,
      time,
      type,
    };
    this.notifications.unshift(notification);
    this.eventsManager.publish(NOTIFICATION_ACTIONS.update, {
      notifications: [...this.notifications],
    });
    setTimeout(this.remove, notification.time);
  };

  private remove = (): void => {
    this.notifications.pop();
    this.eventsManager.publish(NOTIFICATION_ACTIONS.update, {
      notifications: [...this.notifications],
    });
  };
}
